import React from 'react';
import styles from './MapView.module.css';

const MapView = () => {
  const openMapPopup = (e) => {
    e?.preventDefault();
    const width = 1000;
    const height = 800;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const url = "https://results.mathrubhumi.com/result/mapview/bihar.html";

    window.open(
      url,
      'MapView',
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  };

  return (
    <>
      <h3>MAP</h3>
      <div className={styles.mapContainer}>
        <div className={styles.iframeWrapper}>
          <iframe
            src="https://results.mathrubhumi.com/result/mapview/bihar_home.html"
            title="Bihar Election Results Map"
            className={styles.mapIframe}
            allowFullScreen
            scrolling="no"
          />
          <div className={styles.iframeOverlay} onClick={openMapPopup} />
        </div>
      </div>
    </>
  );
};

export default MapView;
